import { BooksPage, BOOKS_SLUG, type BooksView } from '@givmo/books';
import { ModuleGate } from '@givmo/org-console';
import { useCharityConsole } from '../../console/charity-console-context';
import { useActiveOrg } from '../../org/active-org-context';
import { useRequestAccessDoor } from '../../components/request-access-context';
import { NotFound } from '../../components/not-found';
import { useModuleNavigate } from '../../console/use-console-squares';
import { useTurnOnHref } from '../../console/use-turn-on-href';

/** The shared Books page behind the module gate, on the page its route names. */
export function CharityBooksMount({ view }: { view?: BooksView }) {
  const { pending, errored, standings, read, refetch } = useCharityConsole();
  const org = useActiveOrg();
  const door = useRequestAccessDoor();
  const navigate = useModuleNavigate();
  const turnOnHref = useTurnOnHref(BOOKS_SLUG);
  const standing = standings?.[BOOKS_SLUG];
  const request = standing?.accessRequest;
  return (
    <ModuleGate
      slug={BOOKS_SLUG}
      label="Books"
      read={{ pending, errored, standings }}
      onRetry={refetch}
      renderNotFound={() => <NotFound />}
      turnOnHref={turnOnHref}
      onNavigate={navigate}
      onRequestAccess={standing?.held === true ? undefined : () => door.open(BOOKS_SLUG)}
      accessRequest={
        request?.status === 'PENDING'
          ? { status: 'pending' }
          : request?.status === 'DENIED'
            ? { status: 'declined', note: request.resolutionNote ?? null }
            : undefined
      }
    >
      <BooksPage
        view={view}
        config={{ orgRef: org.isReady ? org.activeCharityId : null, permissions: read.permissions }}
      />
    </ModuleGate>
  );
}
